export const strokeColors = {
  stroke_field: 'rgba(255,255,255,0.08)',
  stroke_field_hover: 'rgba(255,255,255,0.16)',
  stroke_field_active: 'rgba(255,255,255,0.32)',
  stroke_divider: 'rgba(255,255,255,0.06)',
} as const
